import { autoQueries } from 'shared/api/auto';

import type { TPledgeAutoFields } from 'entities/pledgeAutoForm';
import { selectIsCarInfoLoadingError, selectPledgeAutoData } from 'entities/pledgeAutoForm';

import { setCarInfoStatus, setPledgeAutoFormDictionaries } from '../model/pledgeAutoForm.slice';

import { mapAutoInfoToPledgeAutoFields } from './mapAutoInfoToPledgeAutoFields';

export const tryLoadDataByCarNumberThunk =
  (number: string): ThunkResult<Promise<Nullable<TPledgeAutoFields>>> =>
  async (dispatch, getState) => {
    let carInfo: Nullable<TPledgeAutoFields> = selectPledgeAutoData(getState());
    const isLastTryError = selectIsCarInfoLoadingError(getState());

    if (carInfo.carNumber === number && !isLastTryError) {
      return carInfo;
    }

    try {
      dispatch(setCarInfoStatus('loading'));
      const data = await dispatch(autoQueries.endpoints.getCarInfo.initiate(number, { subscribe: true })).unwrap();

      if (data) {
        carInfo = mapAutoInfoToPledgeAutoFields(data);
        dispatch(setPledgeAutoFormDictionaries(data));
        dispatch(setCarInfoStatus('success'));
      } else {
        dispatch(setCarInfoStatus('empty'));
        return { ...carInfo };
      }
    } catch (e) {
      dispatch(setCarInfoStatus('error'));

      return { ...carInfo, carNumber: number };
    }

    // создаем указатель на новый объект, чтобы не получить защищенный от записи объект через указатель
    return carInfo ? { ...carInfo, carNumber: number } : { carNumber: number };
  };
